export default __webpack_public_path__ + "static/media/clawsofstone.47d4c469.png";